export default {
    appToolbarMinHeight: 64,

    drawerWidthClosed: 64,
    drawerWidthOpen: 212,

    sideBarWidth: 280
};
